import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { agentForHost, cduAgentState } from '../../utils/cduAgentStatus';
import type { AgentHostReport } from '../../utils/cduAgentStatus';

const AgentStatusContext = createContext<{ hosts: Record<string, AgentHostReport>; now: number }>({ hosts: {}, now: 0 });

export function CduAgentStatusProvider({ hosts, now, children }: { hosts: Record<string, AgentHostReport>; now: number; children: ReactNode }) {
  return <AgentStatusContext.Provider value={{ hosts, now }}>{children}</AgentStatusContext.Provider>;
}

export function CduAgentStatus({ hostname, compact = false }: { hostname: string; compact?: boolean }) {
  const { hosts, now } = useContext(AgentStatusContext);
  const state = cduAgentState(agentForHost(hosts, hostname), now);
  return <span className={`monitor-agent ${compact ? 'monitor-agent-compact' : ''}`} title={state.detail} aria-label={`CDU Agent: ${state.label}${state.version ? `, version ${state.version}` : ''}. ${state.detail}`}>
    {!compact && <span className="monitor-tone-muted">CDU Agent</span>}
    <span className={`monitor-agent-state monitor-tone-${state.tone}`}><span className="monitor-health-dot" aria-hidden="true" />{state.label}</span>
    <span className="monitor-agent-version monitor-tone-muted">{state.version ? `v${state.version}` : 'Version not reported'}</span>
  </span>;
}
